import * as React from 'react'

import { ModalWrapper as ModalWrapperPresenter, IProps } from './presenter'

export const ModalWrapper = (props: IProps): JSX.Element => {
  return <ModalWrapperPresenter {...props} />
}

export default ModalWrapper
